import { useSelector } from "react-redux";
import InfoTooltipElement from "../../shared/infoTooltipElement/InfoTooltipElement";

const MessaggioProdottoRegalo = () => {
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  return (
    <div className="w-full relative bg-ribola-chelsea-cucumber text-white text-center mt-8 px-3 py-2">
      <div
        className="mr-2 sm:mr-3 font-opensanssemibold text-sm"
        dangerouslySetInnerHTML={{
          __html: genericheTranslation.msgprodottoregalato1.itemName,
        }}
      />
      <div
        className="mr-2 sm:mr-3  font-opensanssemibold text-lg"
        dangerouslySetInnerHTML={{
          __html: genericheTranslation.msgprodottoregalato2.itemName,
        }}
      />
    </div>
  );
};

export default MessaggioProdottoRegalo;
